import { useEffect, useState } from 'react';
import { Modal, Form, Button, Dropdown, Container } from 'semantic-ui-react';
import { useAuth } from "../../App";
import { sizeOptions } from "../../utils/qrformat";

export default function QRDownloadDialog({
  open,
  onClose,
  onSubmit
}) {
  const { user } = useAuth();
  const [selectedSize, setSelectedSize] = useState(null);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (!open) {
      setSelectedSize(null);
      setLoading(false);
    }
  }, [open]);


  const handleSubmit = () => {
    onSubmit(selectedSize)
    setLoading(true)
  }

  const handleDropdownChange = (e, { value }) => {
    setSelectedSize(value);
  };

  const canSubmit = selectedSize != null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="tiny"
      closeOnDimmerClick={false}
    >
      <Modal.Header>Stiahnuť QR nálepku</Modal.Header>
      {loading ? <Modal.Content>
        <p style={{width: '100%', textAlign: 'center'}}>...Prosím čakajte...</p>
        <Button
          type="submit"
          color='yellow'
          fluid
          size="large"
          disabled
          loading
          content='Stiahnuť'
        />
      </Modal.Content> :
        <Modal.Content>
          <p>
            Tu si môžeš stiahnuť nálepku ako obrázok. Vytlač si ju a nechaj sa kontaktovať.
          </p>
          <Form>
            <Container style={{ margin: '1rem' }}>
              <Dropdown
                placeholder='Vyber veľkosť'
                fluid
                selection
                onChange={handleDropdownChange}
                options={sizeOptions}
              />
            </Container>

            <Button
              type="submit"
              color='yellow'
              fluid
              size="large"
              loading={loading}
              onClick={handleSubmit}
              disabled={!canSubmit}
              content="Stiahnuť"
            />

            <Button
              type="button"
              basic
              fluid
              size="large"
              disabled={loading}
              onClick={onClose}
              style={{ marginTop: 8 }}
              content="Zrušiť"
            />
          </Form>
        </Modal.Content>
      }

      <style>{`
        @media (max-width: 480px) {
          .ui.modal > .content { padding-top: 1rem; padding-bottom: 1rem; }
          .ui.modal .ui.form .field > label { margin-bottom: .4rem; }
        }
        .ui.dimmer { background-color: rgba(0, 0, 0, 0.5);}
      `}</style>
    </Modal >
  );
}